import React from 'react';

import ProjectItem from '../../Main/Components/Project/ProjectItem';

import { useSelector } from 'react-redux';

const Pages = () => {
   const project = useSelector(state => state.project.project);
   return (
      <main className='project_component' id='project'>
         <div className="project_page--block _container">
            <div className="project_content--text">
               <div className="project--front_title">Recent Projects</div>
               <div className="project--subb">With tools to make every part of your process more human and a support team excited to help you, getting started with us never been easier.</div>
            </div>
            <div className="project_block">
               {project.map(el => (
                  <ProjectItem key={el.id} item={el} />
               ))}
            </div>
         </div>
      </main>
   )

}

export default Pages;
